import { gql } from '../../__gql__/gql';

export const FLIGHT_INFO = gql(`
  query FlightInfo($params: FlightInfoRequestParams!, $skip: Boolean!) {
    flightInfo(params: $params) @skip(if: $skip) {
      flightNumbers {
        flightNumber
      }
    }
  }
`);

export const FLIGHTS_INFO = gql(`
  query FlightsByHubIds($params: FlightsByHubIdsRequestParams!) {
    flightsByHubIds(params: $params) {
      flightDetails {
        originalDepartureTimeLocal
        originalArrivalTimeLocal
        flightDesignators {
          airlineCode
          flightNumber
          airlineName
        }
      }
      originHubDetails {
        name
        iataCode
        cityName
        countryCode
      }
    }
  }
`);
